import { Dimension } from '@/types/config'
import { getInclusionOptions } from '../logicHelpers'

const segmentsSource = ({
  ignoreSegmentGroups
}: {
  ignoreSegmentGroups: Dimension[]
}) => {
  const segmentGroupStore = useSegmentGroupStore()
  const { segmentGroups } = storeToRefs(segmentGroupStore)
  const ignoreIds = (ignoreSegmentGroups || []).map((g) => g.id)

  const eligibleGroups = segmentGroups.value.filter(
    (group) => !ignoreIds.includes(group.id)
  )

  return {
    types: eligibleGroups.map((group) => ({
      label: group.name,
      value: group.id
    })),
    inputs: [
      {
        $formkit: 'select',
        key: 'segment-includes',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string }) =>
          condition.$source === 'segments'
      },
      ...eligibleGroups.map((group) => {
        return {
          $formkit: 'multiselect',
          key: 'segment-select',
          name: 'segmentId',
          multiple: true,
          'open-on-focus': true,
          'clear-search-on-open': true,
          options: group.segments.map((segment) => ({
            label: stripHtml(segmentName(segment)),
            value: segment.id
          })),
          can: (condition: {
            $source: string
            $type: string
            operator: string
          }) =>
            condition.$source === 'segments' &&
            condition.$type === group.id &&
            (condition.operator || '').includes('include')
        }
      })
    ]
  }
}

export default segmentsSource
